import AddIcon from "@mui/icons-material/Add";
import { Button } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import React from "react";
import { useTranslation } from "react-i18next";

const SubmitButtonForm = (props) => {
  const translateForm = "global";
  const { id, disabled } = props || {};
  const { t } = useTranslation();

  return (
    <Button
      type="submit"
      variant="contained"
      color="success"
      size="small"
      disabled={disabled}
      startIcon={id ? <EditIcon /> : <AddIcon />}
    >
      {id ? t(`${translateForm}.editBtn`) : t(`${translateForm}.createBtn`)}
    </Button>
  );
};

export default SubmitButtonForm;
